import {Component, OnInit} from '@angular/core';
import {EnvironmentService} from './core/services/environment.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'ryds-jtp';

  constructor(private environmentService: EnvironmentService) {
  }

  ngOnInit(): void {
    this.environmentService.referrer = document.referrer;
    console.log('referrer', document.referrer, this.environmentService.referrer);
  }
}
